module.exports = __webpack_public_path__ + "static/pledge_banner-554535c2bdd3d5cdc25df94f5c499d40.png";